import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrentImg from "../../../../../components/common/SelectingWarrentImg"

const LiquidityVolumes = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("")
    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main" className='Common_warrent'>
                <div id="maintable" className='liquidity_sec Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }}>Previous Topic</div>
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Market Makers</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>Market Makers</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Liquidity vs Volume</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>How we hedge</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table thead th{\n                padding:1em;  \n            }\n            .contentbox table tbody td,\n            .contentbox table tbody th{\n                padding:0.5em;\n                color:#000000;\n                text-align:center;\n            }\n            .contentbox table tbody td\n            {\n                background-color: #FFF4D2;\n            }\n            .contentbox table tbody th{\n                background-color: #FFD400;\n            }\n            .xxs .ctable{\n                font-size:11px;\n            }\n            .xxs .contentbox table tbody td,\n            .xxs .contentbox table tbody th{\n                padding:0.2em;\n            }\n            .imgholder img,.imgholder .imghtxt{\n                max-width:538px;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>The role of a designated market maker is to provide liquidity in the warrants by providing continuous buy and sell quotes. In doing so, the market makers provide liquidity in the warrants so that investors can easily enter and exit their trades. The quality of the market maker is often a big factor for investors choosing a warrant.</p>
                                            <div className="imgholder">
                                                <img style={{ maxWidth: '562px' }} src='/img/education/liquidity_traded_volume_table1.png' />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/liquidity_traded_volume_table1Mob.png")}}
                                                    >View Chart
                                                    </div>
                                                </div>

                                            </div>

                                            <p>
                                                Typically, a market maker will use a semi-automated trading system to enter their quotes, however this normally requires a lot of human interaction and control. The trading system will enter bid and offer quotes in the warrants based on the price in the underlying share. As the price in the underlying moves, the market maker’s quotes will also adjust. Some market making systems will also change their bid and offer volumes to reflect the volume in the underlying share.<br /><br />
                                                In Malaysia, there are a few exemptions to the continuous quoting requirements, these can be found in the issuers’ listing documents. The most common being, when the warrant value falls below the minimum bid of MYR 0.005, in this case the warrant is considered worthless and the market maker is no longer required to provide a bid price.<br /><br />
                                                A common misconception regarding liquidity is that only warrants with high traded volume are liquid. In the below example, we demonstrate that this is often incorrect.
                                            </p>
                                            <h2>A look at Warrant Liquidity</h2>
                                            <div>
                                                <div className="imgholder">
                                                    <div className="imghtxt">Warrant A</div>
                                                    <img src='/img/education/liquidity_traded_volume_table2.png' />
                                                    <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/liquidity_traded_volume_table2MOb2.png")}}
                                                    >View Chart
                                                    </div>
                                                </div>  
                                                </div>
                                                <div className="imgholder">
                                                    <div className="imghtxt">Warrant B</div>
                                                    <img src='/img/education/liquidity_traded_volume_table3.png' />
                                                    <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/liquidity_traded_volume_table3mob3.png")}}
                                                    >View Chart
                                                    </div>
                                                </div>
                                                </div>

                                            </div>
                                            <p>
                                                The above tables show similar warrants A and B listed over the same underlying share. Warrant A is an actively traded warrant, with 6.2 million in volume for the day, while Warrant B has only 200 thousand traded. Some investors may assume that Warrant B is illiquid and avoid trading this warrant.<br /><br />
                                                In actual fact, the liquidity for both warrants is very similar as both have the same number of warrants on the bid and offer for investors to enter and exit their trade. The liquidity of a warrant is more a function of the volume provided on the bid and offer by the market maker, rather than the number of times a warrant has actually traded.<br /><br />
                                                Investors choosing which warrant to buy should first consider our <Link to="/edu/select-warrant/selecting-warrant" target="_blank">suggested selection process</Link>. Do not choose a warrant based only on its turnover as this may not be the right warrant for you. The quality and reputation of the market maker is also very important.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/market-marker/how-we-hedge">
                                                <span className="prevname "> How we hedge</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/market-marker/how-we-hedge">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/market-marker">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/market-marker">
                                                <span className="prevname ">Market Makers</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
                <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl}/>
            </div>

        </div>
    );
}
export default LiquidityVolumes;